module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top_nav"
  }, [_c('div', {
    staticClass: "nav_menu"
  }, [_c('nav', {
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "nav toggle"
  }, [_c('a', {
    attrs: {
      "id": "menu_toggle"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleSidebar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('UserPanel')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43949fc9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Topmenu.vue
// module id = 342
// module chunks = 1